import Layout from '@/layout'
export default [
    {
        path: '/company-reports',
        component: Layout,
        children: [
            {
                path: '',
                name: 'companyReportIndex',
                component: () => import('./Index'),
                meta: { title: 'Company Report', icon: 'dashboard' },
                adminOnly: false,
            },
            {
                path: 'detail-report',
                name: 'companyDetailReport',
                component: () => import('./Detail'),
                hidden: true,
            },
            {
                path: 'quiz-report',
                name: 'companyQuizReport',
                component: () => import('./QuizReport'),
                hidden: true,
            },
            {
                path: 'attendance-report',
                name: 'companyAttendanceReport',
                component: () => import('./AttendanceReport'),
                hidden: true,
            },
        ]
    },
]